module.exports = __webpack_public_path__ + "img/Frame 1098one1.6753ad03.png";